import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Typography from '@ui/Typography';

const useStyles = makeStyles()(theme => ({
  description: {
    padding: theme.spacing(2, 3),
  },
  descriptionText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    wordBreak: 'break-all',
  },
  divider: {
    marginTop: theme.spacing(2.5),
    marginLeft: 'calc(7% * -1)',
    marginRight: 'calc(7% * -1)',
    '&.MuiDivider-root': {
      backgroundColor: theme.palette.grey[800],
    },
  },
}));

const DictionarySuggestionDescription = ({
  wordInput,
}: {
  wordInput: string;
}) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.description}>
      <Box className={classes.descriptionText}>
        <Typography variant="h3" bold>{`"${wordInput.trim()}"`}</Typography>
      </Box>
    </Box>
  );
};

export default DictionarySuggestionDescription;
